setTimeout(function(){
  if (document.querySelector('.owl-carousel') != null) {




$('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    autoplay: true,
    center: true,
    responsive:{
        0:{
            items:5
        },
        600:{
            items:7
        },
        1000:{
            items:9
        }
    }
})
 







    
    //document.querySelector('.slider').style.display='none';
    //$(".slider").fadeIn("slow");
  }

  //   if ( window.location.pathname == '/pages/contact-us' ){
  //   $("form").submit(function() {
  //   $(this).attr("action", "/contact#contact_form");
  // 	});
  //   }

  $(".add-to-cart-cover").click(function() {
    var soldout = document.querySelector('.btn--sold-out');
   
    if (soldout == null) {
      var stock = parseFloat($(".quantityNumber").text());
      var qnt = parseFloat($(".js-qty input").val());
      var id = document.querySelector('.product-form__variants').value;
      var not = false;
      var params = {
        type: 'GET',
        url: '/cart.js',
        dataType:'json',
        success: $.proxy(function(cartData) {
          cartData.items.forEach(function(item) {
            if (item.id == id) {
              //console.log(stock - item.quantity);
              if ((stock - item.quantity) < qnt) {
                not = true;
                $(".overlay").fadeIn("medium");
                if (item.quantity <= 0) {
                  $(".message-stock-zero").fadeIn("medium");
                } else {
                  $(".message-added-toomuch").fadeIn("medium");
                  $(".message-added-toomuch .messageStockNumber").text(stock);
                }
              }
            }
          });
          if (!not) {
            if (qnt > stock) {
              $(".overlay").fadeIn("medium");
              if (stock <= 0) {
                $(".message-stock-zero").fadeIn("medium");
              } else {
                $(".message-added-toomuch").fadeIn("medium");
                $(".message-added-toomuch .messageStockNumber").text(stock);
              }
            } else {
              $("#warning").val("Lead time for this product is 3-5 days.");
              $(".product-form__cart-submit").click();
            }
          }
        }, this),
        error: $.proxy(function(XMLHttpRequest, textStatus) {
          this.error(XMLHttpRequest, textStatus);
        }, this)
      };

      $.ajax(params);
    }
  });


  $(".buy-now-cover").click(function() {
    var soldout = document.querySelector('.btn--sold-out');
    if (soldout == null) {
      var stock = parseFloat($(".quantityNumber").text());
      var qnt = parseFloat($(".js-qty input").val());
      var id = document.querySelector('.product-form__variants').value;


      if (qnt > stock) {
        $(".overlay").fadeIn("medium");
        if (stock <= 0) {
          $(".message-stock-zero").fadeIn("medium");
        } else {
          $(".message-added-toomuch").fadeIn("medium");
          $(".message-added-toomuch .messageStockNumber").text(stock);
        }
      } else {
        $("#warning").val("Lead time for this product is 3-5 days.");
        $(".shopify-payment-button__button").click();
      }
    }
  });


  $(".cancel").click(function(e) {
    e.preventDefault();
    $(".overlay").fadeOut("medium")
    $(".message").fadeOut("medium");
    $("#warning").val("Lead time:  3-5 days.");
  });

  $(".add-to-cart").click(function(e) {
    e.preventDefault();
    $(".overlay").fadeOut("medium")
    $(".message").fadeOut("medium");
    var m2 = document.querySelector('.m2');
    if (m2 == null) {
      $("#warning").val("Because this product is shipped from Poland lead time is 3-5 weeks.");
    } else {
      $("#warning").val("Because this product is shipped from Poland lead time is approximately 2 months.");
    }
    $(".product-form__cart-submit").click();
  });
  
  $(".buy-now").click(function(e) {
    e.preventDefault();
    $(".overlay").fadeOut("medium")
    $(".message").fadeOut("medium");
    var m2 = document.querySelector('.m2');
    if (m2 == null) {
      $("#warning").val("Because this product is shipped from Poland lead time is 3-5 weeks.");
    } else {
      $("#warning").val("Because this product is shipped from Poland lead time is approximately 2 months.");
    }
    $(".shopify-payment-button__button").click();
  });
  

  $(".add-to-cart-cover-f").click(function(e) {
    e.preventDefault();
    $("#warning").val("Lead time for this product is 3-5 days.");
    $(".product-form__cart-submit").click();
  });
    $(".buy-now-cover-f").click(function(e) {
    e.preventDefault();
    $("#warning").val("Lead time for this product is 3-5 days.");
    $(".shopify-payment-button__button").click();
  });


  $(".edit").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(".product-options").removeClass('po-show');
    var id = '#p-' + $(this).attr('data-line');
    $(id).addClass('po-show');
  });

  $("body").click(function(e) {
    $(".product-options").removeClass('po-show');
  });

  $(".product-options").click(function(e) {
    e.stopPropagation();
  });

  $(".closex").click(function(e) {
    e.preventDefault();
    $(".product-options").removeClass('po-show');
  });

  $(".update").click(function(e) {
    var prId = this.id.substring(2);
    var parent = this.parentElement;
    var variant = parent.querySelector('#s-'+prId);
    if (variant.length > 1) {
      var newvalue = $(variant).val();
      var p = $(variant).val();
      var qnt = $('#v-'+p).attr('data-quantity');
      var itemQuantity = $(variant).attr('data-quantity');
      var property = '';
      var dataline = $(this).attr('data-line');
      if (qnt <= 0) {
        property = 'Because this product is shipped from Poland lead time is 3-5 weeks.';
      } else {
        property = 'Lead time for this product is 3-5 days.';
      }
      $(".loader").fadeIn("slow");
      var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + dataline,
        dataType: 'json',
        success: $.proxy(function(cart) {
          console.log('usuniete');
          console.log(newvalue);
          jQuery.post('/cart/add.js', {
            quantity: itemQuantity,
            id: newvalue,
            properties: { 'Note' : property },
          });
        }, this)
      };
      $.ajax(params);
      setTimeout(function(){
        window.location.reload(1);}, 1000);
    } else {
      $(".product-options").removeClass('po-show');
    }
  });
  $(".site-header__menu-toggle--close").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(".main-content").click();
  });
  $(".loader").fadeOut("slow");
  
  
  function blockMain() {
  var p = $('p:contains("3-5 days")');
    p = p.toArray();
    p.forEach(function(e){
      var c = e.className;
      var id = c.substring(9);
      var qnt = e.parentElement.parentElement.querySelector('.js-qty__input').value;
      var input = e.parentElement.parentElement.querySelectorAll('.js-qty__adjust');
      var n = e.parentElement.parentElement.querySelector('.js-qty__input');
      var params = {
        type: 'GET',
        url: '/cart.js',
        dataType:'json',
        success: $.proxy(function(cartData) {
          cartData.items.forEach(function(item) {
   
            if (e.innerText.includes('3-5 days')) {
              if (item.id == id) {


                if (item.quantity >= qnt) {
                  input.forEach(function(e){
                    e.disabled = true;
                  });
                  n.disabled = true;
                }
              }
            }
          });
        }, this),
        error: $.proxy(function(XMLHttpRequest, textStatus) {
          this.error(XMLHttpRequest, textStatus);
        }, this)
      };

      $.ajax(params);
    });
  }

  if ( window.location.pathname == '/cart' ){
    blockMain();
  }


  if ( window.location.pathname == '/' ){


    var products = document.querySelectorAll('.product-card');

    products.forEach(function(e){

      
      var date = '';
      if(e.querySelector('.date')) {
        date = e.querySelector('.date').innerText;
      }
      
      var n = e.querySelector('.new-main');
      var daysOld = Date.now() - Date.parse(date);
      var daysMax = 14 * 24 * 60 * 60 * 1000;
      if (daysMax > daysOld ) {
        n.style.display = 'block';
      }
    });

    let searchIcon = document.querySelector('.lupka .icon');
  }
  var draw = document.querySelectorAll(".meganav__list .drawer__nav-item");
  var links = document.querySelectorAll(".meganav__list .jsclick");

  links.forEach(function(e){
    e.addEventListener("click", function(event) {
      event.preventDefault();
    });
  });

  draw.forEach(function(e){
    e.addEventListener("click", function(event) {
      var b = e.querySelector('div .bib');
      b.click();
    });
  });

  $('.li-hover-js').on('touchend', function(e) {
    e.preventDefault();
    $(this).toggleClass('hover-js');
    console.log(this);
  });
  let filter = document.querySelector('.boost-pfs-filter-wrapper');
  if (filter) {
    setTimeout(function(){
      filter.classList.toggle('filter-bubble-visible');
    }, 500);
    setTimeout(function(){
      filter.classList.toggle('filter-bubble-visible');
    }, 6000);
  }
}, 500);

